import { CORE_PLUGIN } from '@/core'
import type { ConsolePageOption, ConsolePageService, Plugin } from '@/plugins'
import { PLUGIN_CONSOLE_PAGE } from '@/plugins/builtin/BuiltinPluginSymbol'
import { defineStore } from 'pinia'
import {
  container,
  instanceCachingFactory,
  registry,
  singleton
} from 'tsyringe'
import type { RouteRecordRaw } from 'vue-router'

import AddressesList from './address/view/AddressesList.vue'

export const orderStore = defineStore('orderStore', {
  state: () => ({}),
  getters: {

  },
  actions: {

  },
})

export type orderInfoOption = {
  //
}

export type orderInfoAction = {
  //
}

export type orderInfoGetter = {
  //
}

export type orderInfoService = orderInfoAction & orderInfoGetter

/**
 * 插件的Option定义
 */
@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<orderInfoOption, orderInfoService>>(
      (c) => c.resolve(orderInfoPLugin)
    ),
  },
])
export class orderInfoPLugin implements Plugin<orderInfoOption, orderInfoService>{
  id: string | symbol = ''
  options: orderInfoOption
  service: orderInfoService
  constructor() {
    const instantiationStore = orderStore()
    this.service = instantiationStore
    this.options = instantiationStore.$state
  }

  init(): void {
    const plugin = container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(PLUGIN_CONSOLE_PAGE)
    const orderRoute = [
      { name: "order-address-home", path: "orders/addresses", component: AddressesList }
    ] as RouteRecordRaw[]
    orderRoute.forEach(item => {
      plugin.service.addChildRoute(item)
    })

  }

  initialized(): void {
    //
  }
}
